// src/frontend_react/src/layouts/AdminLayout.js 
import React from 'react';
import { Outlet } from 'react-router-dom';

// Sidebar Component
import AdminSidebar from '../components/navigation/AdminSidebar'; // Points to the AdminSidebar

// Base UI Components for Layout
import Stack from '../components/ui/Stack/Stack';
import Box from '../components/ui/Box/Box';

// Shared layout styles
import styles from './Layouts.module.css'; // Path to your Layouts.module.css

const AdminLayout = ({ children }) => {
  const appHeaderHeight = 'var(--app-header-height, 65px)'; // Default to 65px if var not set

  return (
    <Stack 
      direction="row" 
      className={styles.layoutMain}
      style={{ 
        minHeight: `calc(100vh - ${appHeaderHeight})`,
        height: `calc(100vh - ${appHeaderHeight})`
      }}
    >
      <AdminSidebar /> {/* Using AdminSidebar here */}
      
      <Box
        as="main"
        flexGrow={1}
        p="lg" // Padding for the content area
        className={styles.contentArea}
        style={{ 
          overflowY: 'auto',
          height: '100%'
        }} 
      >
        {children || <Outlet />} {/* Render AdminDashboard and its routes via Outlet */}
      </Box>
    </Stack>
  );
};

export default AdminLayout;